import { CommissionEchantillonEdition } from './commission-echantillon-edition.model';
import { CommissionJureEdition } from './commission-jure-edition.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class CommissionJuryEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        numero: { key: 'numero', optional: true },
        cahiers: { key: 'cahiers', optional: true, default: () => [] },
        jures: { key: 'jures', converter: new (ArrayClassConverterFactory.build(CommissionJureEdition))(), optional: true, default: () => [] },
        echantillons: {
            key: 'echantillons',
            converter: new (ArrayClassConverterFactory.build(CommissionEchantillonEdition))(),
            optional: true,
            default: () => []
        }
    };

    id: number;
    numero: number;
    cahiers: string[];
    jures: CommissionJureEdition[];
    echantillons: CommissionEchantillonEdition[];
}

/*
 private Long id;
    private String numero;
    private List<String> cahiers = new ArrayList<>();
    List<CommissionEchantillonEditionDTO> echantillons  = new ArrayList<>();
    List<CommissionJureEditionDTO> jures = new ArrayList<>();
*/
